import {Injectable} from '@angular/core';
import {Resolve, ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs/Observable';

import {EventService} from '../event.service';


@Injectable()
export class AllEventsAllOrganizationsResolver implements Resolve<any> {
	constructor(
		private eventService: EventService
	) {}


	params: any = {};


	resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
		// console.log('AllFilmsResolver called    #1');
		// let startResolve = Date.now();

		this.params = JSON.parse(JSON.stringify(route.params));

		let thePromise = new Promise((resolve, reject) => {
			// this.reviewerFilmService.getFilms()
			this.eventService.getEventsAllOrganizations()
				.then((allEventsAllOrganizations: any) => {

					// let endResolve = Date.now();
					// console.log('AllFilmsResolver called    #2, took ' + (endResolve - startResolve) + ' msec' );


					let allEventsAllOrganizationsInfo = {
						allEventsAllOrganizations: allEventsAllOrganizations.allEventsAllOrganizations.events,
						params: this.params
					};
					resolve(allEventsAllOrganizationsInfo);
				})
				.catch((err) => {
					return reject(err);
				});
		});

		return Observable.fromPromise(thePromise);
	}
}



// WEBPACK FOOTER //
// /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/app/services/resolvers/all-events-all-organizations.resolver.ts